import { render, staticRenderFns } from "./uploadDocuments.vue?vue&type=template&id=0a18d234&scoped=true"
import script from "./uploadDocuments.vue?vue&type=script&lang=js"
export * from "./uploadDocuments.vue?vue&type=script&lang=js"
import style0 from "./uploadDocuments.vue?vue&type=style&index=0&id=0a18d234&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18d234",
  null
  
)

export default component.exports